module.exports = __webpack_public_path__ + "static/media/mumbai.614dbd85.png";